import { PhoneOutlined } from "@ant-design/icons";
import { Input, Form, Select } from "antd";
import countryCode from "../../utils/countryCode.json";

const PhoneNumInput = ({ onChange, ...rest }) => {
  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select
        showSearch
        defaultValue={"+966"}
        style={{
          width: 70,
        }}
      >
        {countryCode?.map((code, i) => (
          <Select.Option key={i} value={code.dial_code}>
            {code.dial_code}
          </Select.Option>
        ))}
        {/* <Select.Option value="86">+86</Select.Option>
        <Select.Option value="87">+87</Select.Option> */}
      </Select>
    </Form.Item>
  );

  const handleInputChange = (e) => {
    const value = e.target.value;
    const regex = /^\+?\d*$/; // Regex to allow a string starting with an optional plus and followed by any number of digits
    // console.log(value, "vvvvvvvvvvvvvvvvvvvvv");
    if (regex.test(value)) {
      if (onChange) {
        onChange(value);
      }
    }
  };

  const handleTextEnter = (e) => {
    let regex = /^[+]?[0-9]*$/; // this work fine

    // Check if the arrow-down key is pressed and the input value is empty or starts with a negative sign
    if (
      e.key === "ArrowDown" &&
      (e.target.value === "" || e.target.value.startsWith("-"))
    ) {
      e.preventDefault(); // Prevent the default behavior of the arrow-down key
    } else {
      const isValid = regex.test(e.key);
      if (!isValid) {
        e.preventDefault();
      }
    }
  };

  return (
    <Input
      onKeyPress={handleTextEnter}
      onChange={handleInputChange}
      style={{ borderRadius: "16px" }}
      addonBefore={prefixSelector}
      suffix={<PhoneOutlined rotate={90} style={{ color: "#8F8F8F" }} />}
      size="large"
      {...rest}
    />
  );
};

export default PhoneNumInput;
